module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MedalHallView.js"));
	}, "MedalHallView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MedalHallView!./src/pages/Learn/PromotionTree/Medal/MedalHallView.js
// module id = 2158
// module chunks = 367